import { CreateAccountModal } from 'components/accounts/CreateAccountModal'
import { CreateHoldingModal } from 'components/holdings/CreateHoldingModal'
import { MenuItem, NavigatorMenuButton, PlusIcon, useModal, useRouter } from '@forgeglobal/design-framework'
import { OpportunityModal } from 'components/opportunities/OpportunityModal'
import { Routes } from 'util/Routes'
import { matchPath } from 'react-router'
import { useAccountNameQuery, useBaseIssuerAccountQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'

interface IdRoute {
  id?: string
  type?: string
}

export const QuickAddButton = () => {
  const { history } = useRouter()
  const pathParams = matchPath<IdRoute>(window.location.pathname, {
    path: ['/:type/:id', '/console/:type/:id'],
    exact: true,
    strict: false,
  })?.params

  const accountId = ((pathParams?.type ?? '') === 'accounts' && pathParams?.id) || undefined
  const issuerAccountId = (pathParams?.type === 'issuers' && pathParams?.id) || undefined

  const accountData = useAccountNameQuery({ variables: { id: accountId }, skip: !accountId })?.data?.account
  const companyData = useBaseIssuerAccountQuery({
    variables: { issuerId: issuerAccountId },
    skip: !issuerAccountId,
  })?.data?.account?.issuer_account?.company

  const fromAccount = accountData && { accountId: accountData.id, accountName: accountData.name }
  const fromIssuer = companyData && { companyId: companyData.id, companyName: companyData.name }
  const [openCreateHoldingModal, hideCreateHoldingModal] = useModal(() => {
    return <CreateHoldingModal hideModal={hideCreateHoldingModal} fromIssuer={fromIssuer} fromAccount={fromAccount} />
  }, [accountData, companyData])
  const [openCreateOpportunityModal, hideCreateOpportunityModal] = useModal(() => {
    return <OpportunityModal hideModal={hideCreateOpportunityModal} accountId={accountId} issuerId={issuerAccountId} />
  }, [accountId, issuerAccountId])
  const [openCreateAccountModal, hideCreateAccountModal] = useModal(() => {
    return <CreateAccountModal hideModal={hideCreateAccountModal} />
  }, [accountData, companyData])
  const openCreateSegmentPage = () => {
    history.push(Routes.segmentForm())
  }

  return (
    <Fragment>
      <NavigatorMenuButton icon={<PlusIcon />} text="Create">
        <MenuItem onClick={openCreateAccountModal}>Account</MenuItem>
        <MenuItem onClick={openCreateOpportunityModal}>Opportunity</MenuItem>
        <MenuItem onClick={openCreateHoldingModal}>Holding</MenuItem>
        <MenuItem onClick={openCreateSegmentPage}>Segment</MenuItem>
      </NavigatorMenuButton>
    </Fragment>
  )
}
